var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-bank-details-wrapper":""}},[_c('bank-details-form',{attrs:{"error-in-bank-details":_vm.errorInBankDetails}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }